import React from "react";

const HelpModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl p-5 w-[90%] max-w-md mx-auto shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Name + Phone Number Row */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-2">
          <h2 className="text-xl font-semibold text-black">TMW SUPPORT</h2>
          <p className="text-lg font-bold text-blue-600 sm:ml-4">
            +91 9892233193
          </p>
        </div>

        {/* Support Text */}
        <p className="text-sm text-gray-600">
          For assistance, please call this number.
        </p>
      </div>
    </div>
  );
};

export default HelpModal;
